/**
 * ================================================================================
 * COMPONENTE: BottomNav (Mobile)
 * PROPÓSITO: Navegação inferior para dispositivos móveis
 * ================================================================================
 */
import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Wallet, ArrowLeftRight, PieChart, Settings } from 'lucide-react';

const links = [
  { to: '/',              icon: LayoutDashboard, label: 'Home' },
  { to: '/wallets',       icon: Wallet,          label: 'Carteiras' },
  { to: '/transactions',  icon: ArrowLeftRight,  label: 'Transações' },
  { to: '/budgets',       icon: PieChart,        label: 'Orçamento' },
  { to: '/settings',      icon: Settings,        label: 'Config.' },
];

export default function BottomNav() {
  return (
    <div className="bottom-nav">
      <div className="bottom-nav-items">
        {links.map((link) => {
          const Icon = link.icon;
          return (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon className="icon" />
              <span>{link.label}</span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
}
